const generateRandomString = (length = 10) => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

const generateRandomNumber = (length = 10) => {
  const characters = '0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

export const getGiftCards = {
  giftCardProvider: 'Worldpay',
  poolAccountSettings: [
    { accountId: generateRandomString() },
    { accountToken: generateRandomString() },
    { acceptorId: generateRandomNumber() },
    { terminalId: generateRandomString() },
    { storeCardId: generateRandomString() },
    { storeCardPassword: generateRandomString() },
  ],
};

export const getLocationFields = [
  {
    locationId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
    locationName: 'RUSH QA Store for Cypress',
    locationConfig: {
      accountId: generateRandomString(),
      accountToken: generateRandomString(),
      acceptorId: generateRandomNumber(),
      terminalId: generateRandomString(),
      storeCardId: generateRandomString(),
      storeCardPassword: generateRandomString(),
    },
  },
  {
    locationId: '071c3b40-b6e9-4bd0-91cc-d75c432123ba',
    locationName: 'New Menu import 2',
    locationConfig: {
      accountId: generateRandomString(),
      accountToken: generateRandomString(),
      acceptorId: generateRandomNumber(),
      terminalId: generateRandomString(),
      storeCardId: generateRandomString(),
      storeCardPassword: generateRandomString(),
    },
  },
  {
    locationId: '12e9ccb5-c1db-47ad-864f-4fb533d18804',
    locationName: 'DEV TEAM - LIGHTSPEED',
    locationConfig: {
      accountId: generateRandomString(),
      accountToken: generateRandomString(),
      acceptorId: generateRandomNumber(),
      terminalId: generateRandomString(),
    },
  },
  {
    locationId: '1a972340-2b41-42d7-8dd0-ca7244a4c101',
    locationName: 'DEV TEAM - TOAST',
    locationConfig: {
      accountId: null,
      accountToken: null,
      acceptorId: null,
      terminalId: null,
      storeCardId: null,
      storeCardPassword: null,
    },
  },
  {
    locationId: '21e59806-f517-4788-a670-ca82d4d7743c',
    locationName: 'Test Menu import 2',
    locationConfig: {
      accountId: generateRandomString(),
      accountToken: generateRandomString(),
      acceptorId: generateRandomNumber(),
      terminalId: generateRandomString(),
    },
  },

  {
    locationId: '32d70411-937f-4027-bc4f-c8a74212e810',
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(36),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(36),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(36),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(36),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(36),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(36),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
  {
    locationId: generateRandomString(36),
    locationName: 'Test Menu import',
    locationConfig: {
      squareLocationId: null,
    },
  },
];
